export const textPageStatik = {
  crumbs_nav_privacy: [
    { title_ua: 'Головна', title_ru: 'Главная', link: '/' },
    {
      title_ua: 'Конфіденційність',
      title_ru: 'Конфиденциальность',
      link: '/privacy-policy/',
    },
  ],
  crumbs_nav_terms: [
    { title_ua: 'Головна', title_ru: 'Главная', link: '/' },
    {
      title_ua: 'Угода користувача',
      title_ru: 'Пользовательское соглашение',
      link: '/terms-of-use/',
    },
  ],
};
